import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpEvent
} from "@angular/common/http";
import { inject, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError, Observable } from "rxjs";
import { NotificationService } from "../../shared/utils/notification.service";
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const ngZone = inject(NgZone);
  const notificationService = inject(NotificationService);
  return next(req).pipe(
   catchError((error: HttpErrorResponse) => {
    let errorMsg = "";
      if (error?.error?.message == 'Token Expired') {
        notificationService.notification('danger',"Your session has expired due to inactivity. Please log in again to continue.", "Session Expired", null);
        ngZone.run(() => router.navigate(['/login']));
        return throwError(() => error);
      }else if(error?.error?.message =='Invalid Token'){
        notificationService.notification('danger', "Your session is invalid. Please log in again to continue.", "Invalid Session", null);
        ngZone.run(() => router.navigate(['/login']));
        return throwError(() => error);
      }
    if (error.error instanceof ErrorEvent) {
     console.log("this is client side error",error,"error.error",error.error );
     errorMsg = `Client Error: ${error.error.message}`;
    } else {
     console.log("this is server side error");
     errorMsg = `Server Error Code: ${error.status}, Message: ${error.message}`;
    }
 
    console.log(errorMsg);
    return throwError(() => errorMsg);
   }),
  );
};
